import { AbcGalleryComponent, GalleryModel, GalleryStyle, IGallery } from '@barthauer/abc/ui-components';
import { Item } from 'devextreme/ui/accordion';
import { DataFormService } from '../../data-form.service';
import { DataFormSettings } from '../settings.model';
import { UiCreatorBase } from './ui-creator-base';

export class AbcGalleryUiCreator extends UiCreatorBase {
  constructor(private service: DataFormService, private settings: DataFormSettings) {
    super(service, settings);
  }

  public async create(dataSource?: GalleryModel[] | Item[]): Promise<HTMLElement> {
    const style: GalleryStyle = {
      height: '100%',
      swipeEnabled: true,
      visible: true,
      showIndicator: true,
      showNavButtons: false,
      loadHtml: true,
      animationEnabled: false,
      class: 'data-form-gallery',
    };

    const galleryAttr: IGallery = {
      id: 'gallery',
      dataSource: <GalleryModel[]>dataSource ?? [],
      setGalleryStyle: (galleryStyle: GalleryStyle) => (galleryStyle = style),
    };
    const cpt = this.service.abcContainer.createComponent(this.tabsDirective, AbcGalleryComponent, galleryAttr);

    const domElement = cpt.domElement;
    domElement.id = 'galleryInDataForm';

    if (!dataSource) {
      this.settings.abcGalleryCptRef = {
        componentRef: cpt?.componentRef,
        domElement: cpt?.domElement,
      };
    }

    return domElement;
  }

  public update(identifier: string): void {
    const dataSource: GalleryModel[] = [];
    let selectedIndex: number = -1;
    if (this.settings.htmlGroups.length) {
      let index = 0;
      const indexes: number[] = [];
      for (const grp of (this.settings.htmlGroups[0] as any).cbxGroupDataSource) {
        const propName = 'is' + grp.name + 'Checked';
        const isChecked = this.settings[propName];
        if (isChecked !== false) {
          indexes.push(index);
        }
        index++;
      }
      for (index of indexes) {
        const grp = this.settings.htmlGroups[index];
        const arr: string[] = [];
        for (let index2 of indexes) {
          const item = grp?.cbxGroupDataSource[index2];
          if (identifier === item?.name) {
            selectedIndex = arr.length;
          }
          arr.push(item?.caption);
        }
        const clone: any = {};
        clone.html = grp?.html;
        clone.cbxGroupDataSource = arr;
        dataSource.push(clone);
      }
    }
    const g: AbcGalleryComponent = this.settings.abcGalleryCptRef?.componentRef?.instance;
    if (g) {
      g.dataSource = dataSource;
      g.htmlAttributes.dataSource = dataSource;

      if (selectedIndex >= 0) {
        g.selectedIndex = selectedIndex;
      } else if (identifier) {
        g.selectedIndex = dataSource.length - 1;
      } else {
        g.selectedIndex = 0;
      }
    }
  }

  public add() {
    // TODO if needed, add an element to the gallery
    return;
  }

  public remove() {
    // TODO if needed, remove an element from the gallery
    return;
  }
}
